import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useTRPC } from '@/utils/trpc';

export const useDeleteObligationAssessmentResultsTRPC = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();
  const mutation = useMutation({
    ...trpc.frontend.obligationAssessmentResult.delete.mutationOptions({
      onSuccess: async () => {
        // COI-889: router-level key — the hand-listed set missed
        // `assessmentResultCount`, the Findings left-nav badge.
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.assessment.pathKey(),
        });
        // COI-889: the obligation's Assessment tab reads this family; its
        // DeleteModal fires the page refetch before the delete resolves.
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.obligationAssessmentResult.pathKey(),
        });
        // COI-889: the Obligations register's rating columns read the nested
        // `assessmentResults`.
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.obligation.register.queryKey(),
        });
      },
    }),
  });

  return {
    deleteObligationAssessmentResults: async (ids: string[]): Promise<void> => {
      await mutation.mutateAsync({ Ids: ids });
    },
    isLoading: mutation.isPending,
  };
};
